'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FieldChooser = require('../components/FieldChooser');

var _FieldChooser2 = _interopRequireDefault(_FieldChooser);

var _OperatorChooser = require('../components/OperatorChooser');

var _OperatorChooser2 = _interopRequireDefault(_OperatorChooser);

var _ValueInput = require('../components/ValueInput');

var _ValueInput2 = _interopRequireDefault(_ValueInput);

var _UniqueValueChooser = require('../components/UniqueValueChooser');

var _UniqueValueChooser2 = _interopRequireDefault(_UniqueValueChooser);

var _ValueTypeChooser = require('../components/ValueTypeChooser');

var _ValueTypeChooser2 = _interopRequireDefault(_ValueTypeChooser);

var _DomainValueChooser = require('../components/DomainValueChooser');

var _DomainValueChooser2 = _interopRequireDefault(_DomainValueChooser);

var _RelativeDateChooser = require('../components/RelativeDateChooser');

var _RelativeDateChooser2 = _interopRequireDefault(_RelativeDateChooser);

var _Form = require('calcite-react/Form');

var _Panel = require('calcite-react/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _Button = require('calcite-react/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Tooltip = require('calcite-react/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _DeleteIcon = require('../icons/DeleteIcon');

var _DeleteIcon2 = _interopRequireDefault(_DeleteIcon);

var _genericUtils = require('../utils/genericUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formControlStyles = {
  marginBottom: '5px',
  justifyContent: 'flex-end'
};

var Expression = function (_Component) {
  _inherits(Expression, _Component);

  function Expression() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Expression);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Expression.__proto__ || Object.getPrototypeOf(Expression)).call.apply(_ref, [this].concat(args))), _this), _this.updateExpression = function (updates) {
      var id = _this.props.id;
      _this.props.updateExpression(_extends({}, updates, { id: id }));
    }, _this.removeExpression = function () {
      var id = _this.props.id;
      _this.props.removeExpression(id);
    }, _this.handleFieldChanged = function (field) {
      _this.setOptionsFromField(field);
    }, _this.handleOperatorChanged = function (operator) {
      _this.updateExpression({ operator: operator });
    }, _this.handleValueChanged = function (value) {
      _this.updateExpression({ value: value });
    }, _this.handleValueTypeChanged = function (valueType) {
      _this.updateExpression({ valueType: valueType });
    }, _this.setOptionsFromField = function (field) {
      var operator = (0, _genericUtils.getValidOperators)(field.type)[0];
      var value = (0, _genericUtils.getDefaultFilterValue)(field);

      _this.updateExpression({
        field: field,
        value: value,
        operator: operator
      });

      _this.setState({
        field: field,
        value: value,
        operator: operator
      });
    }, _this.getValueTypeChooser = function (valueType, disableUnique) {
      if (disableUnique) return null;
      return _react2.default.createElement(_ValueTypeChooser2.default, {
        id: _this.props.id,
        selectedValueType: valueType,
        onChange: _this.handleValueTypeChanged
      });
    }, _this.getValueElement = function (expressionDef) {
      var valueType = expressionDef.valueType,
          field = expressionDef.field,
          operator = expressionDef.operator,
          value = expressionDef.value;

      // Operator does not require a value

      if (operator && operator.omitValue) return null;

      // TODO: need to implement this
      if (valueType === 'unique') {
        return _react2.default.createElement(_UniqueValueChooser2.default, null);
      }

      // NOTE: only supporting coded value domains for now
      if (field && field.domain && field.domain.codedValues) {
        return _react2.default.createElement(_DomainValueChooser2.default, {
          codedValues: field.domain.codedValues,
          selectedValue: value || (0, _genericUtils.getDefaultFilterValue)(field),
          onChange: _this.handleValueChanged
        });
      }

      if (operator && operator.relativeDate) {
        return _react2.default.createElement(_RelativeDateChooser2.default, { value: value, onChange: _this.handleValueChanged });
      }

      // Freeform text input (TextField) or non-relative Date input (DatePicker)
      return _react2.default.createElement(_ValueInput2.default, {
        value: value.code,
        type: (0, _genericUtils.getGenericFieldType)(field && field.type),
        onChange: _this.handleValueChanged
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Expression, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Kinda nasty, but grabs the "first" property in the fields object
      // in the same way the FieldChooser will.
      // const field = this.props.fields[Object.keys(this.props.fields)[0]];
      // this.setOptionsFromField(field);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.fields) return null;

      var _props$expressionDef = this.props.expressionDef,
          field = _props$expressionDef.field,
          operator = _props$expressionDef.operator,
          valueType = _props$expressionDef.valueType;


      return _react2.default.createElement(
        _Panel2.default,
        { style: { backgroundColor: '#f6fdff' } },
        _react2.default.createElement(
          _Form.Fieldset,
          { name: 'expression-' + this.props.id, horizontal: true },
          _react2.default.createElement(
            _Form.FormControl,
            { style: _extends({ flex: '1 0 150px' }, formControlStyles) },
            _react2.default.createElement(_FieldChooser2.default, {
              selectedField: field,
              fields: this.props.fields,
              onChange: this.handleFieldChanged
            })
          ),
          _react2.default.createElement(
            _Form.FormControl,
            { style: formControlStyles },
            _react2.default.createElement(_OperatorChooser2.default, {
              selectedOperator: operator,
              operators: (0, _genericUtils.getValidOperators)(field && field.type),
              onChange: this.handleOperatorChanged
            })
          ),
          _react2.default.createElement(
            _Form.FormControl,
            { style: _extends({ flex: '1 0 150px' }, formControlStyles) },
            this.getValueElement(this.props.expressionDef)
          ),
          _react2.default.createElement(
            _Form.FormControl,
            { style: formControlStyles },
            this.getValueTypeChooser(valueType, this.props.disableUnique)
          ),
          _react2.default.createElement(
            _Form.FormControl,
            { style: formControlStyles },
            _react2.default.createElement(
              _Tooltip2.default,
              { title: 'Remove Expression', placement: 'left' },
              _react2.default.createElement(_Button2.default, {
                style: { margin: '0.25rem 0 0 0' },
                iconButton: true,
                icon: _react2.default.createElement(_DeleteIcon2.default, null),
                onClick: this.removeExpression
              })
            )
          )
        )
      );
    }
  }]);

  return Expression;
}(_react.Component);

exports.default = Expression;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/containers/Expression.js
// module id = 1471
// module chunks = 0